import { SITE_URL } from "@/features/landing/siteUrls";

/**
 * "Back to Delgentic" — the way out of Scheda to the platform home.
 *
 * A plain anchor, not a router Link: the apex is a different origin served by
 * its own bundle, so this is a real navigation. Sitting next to the Scheda mark
 * it reads as the parent brand, which is the point — Scheda is one product on
 * Delgentic, and there should always be a door back.
 */
export function DelgenticHomeLink() {
  return (
    <a
      href={SITE_URL}
      aria-label="Delgentic — platform home"
      title="Back to Delgentic"
      className="inline-flex items-center gap-1.5 rounded-full border border-slate-300 px-2.5 py-1 text-slate-600 transition hover:border-slate-400 hover:bg-slate-100 hover:text-slate-900 dark:border-slate-700 dark:text-slate-300 dark:hover:bg-slate-800"
    >
      {/* The Delgentic node mark, matching the apex navbar's lockup. */}
      <svg width="18" height="18" viewBox="0 0 26 26" fill="none" aria-hidden="true">
        <defs>
          <linearGradient id="dg-home" x1="0" y1="0" x2="26" y2="26" gradientUnits="userSpaceOnUse">
            <stop stopColor="#2779A7" />
            <stop offset="1" stopColor="#49C5B6" />
          </linearGradient>
        </defs>
        <line x1="13" y1="13" x2="4" y2="5" stroke="#94a3b8" strokeWidth="1.2" />
        <line x1="13" y1="13" x2="22" y2="6" stroke="#94a3b8" strokeWidth="1.2" />
        <line x1="13" y1="13" x2="6" y2="21" stroke="#94a3b8" strokeWidth="1.2" />
        <line x1="13" y1="13" x2="21" y2="20" stroke="#94a3b8" strokeWidth="1.2" />
        <circle cx="4" cy="5" r="2.4" fill="#DF6C4F" />
        <circle cx="22" cy="6" r="2.4" fill="#2779A7" />
        <circle cx="6" cy="21" r="2.4" fill="#2779A7" />
        <circle cx="21" cy="20" r="2.4" fill="#DF6C4F" />
        <circle cx="13" cy="13" r="4.4" fill="url(#dg-home)" />
      </svg>
      <span className="hidden text-xs font-medium sm:inline">Delgentic</span>
    </a>
  );
}
